"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var Ruby_Jackpot_2_lines_big_png_1 = __importDefault(require("../../../../../assets/rubyJackpot/images/logo/Ruby-Jackpot-2-lines-big.png"));
var selectors_1 = require("../../../../../contexts/rubyJackpot/selectors");
var Swiper_1 = __importDefault(require("../../utils/Swiper/Swiper"));
var JackpotWinnerSlide_1 = __importDefault(require("./JackpotWinnerSlide"));
var JackpotWinners = function (_a) {
    var isMobile = _a.isMobile, _b = _a.show, show = _b === void 0 ? true : _b;
    var latestWinners = (0, selectors_1.useLatestWinners)();
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)("winners-container", show && "winners-container--show") }, { children: [!isMobile && (0, jsx_runtime_1.jsx)("div", __assign({ className: "logo" }, { children: (0, jsx_runtime_1.jsx)("img", { src: Ruby_Jackpot_2_lines_big_png_1.default, alt: "logo" }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ id: "wrapper-jackpot-text" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ id: "jackpot-text" }, { children: "Tocmai ce au luat jackpotul" })), (0, jsx_runtime_1.jsx)(Swiper_1.default, __assign({ breakpoints: {
                            290: {
                                slidesPerView: 1.3,
                                spaceBetween: 10,
                                slidesPerGroup: 1,
                            },
                            480: {
                                slidesPerView: 1.7,
                                spaceBetween: 10,
                                slidesPerGroup: 2,
                            },
                            667: {
                                slidesPerView: 2.5,
                                spaceBetween: 30,
                            },
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 30,
                            },
                            1200: {
                                slidesPerView: 3.5,
                                spaceBetween: 50,
                            },
                        }, spaceBetween: 50, slidesPerView: 3.5 }, { children: latestWinners.map(function (winner, index) {
                            return (0, jsx_runtime_1.jsx)(JackpotWinnerSlide_1.default, { winner: winner }, "jackpot-winner-".concat(index));
                        }) }))] }))] })));
};
exports.default = JackpotWinners;
